import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ShortLinkRedirect() {
  const { code } = useParams();
  const [state, setState] = useState('loading'); // loading | notfound | redirecting

  useEffect(() => {
    axios.get(`${API}/short-links/${code}`)
      .then(({ data }) => {
        setState('redirecting');
        window.location.replace(data.target_url);
      })
      .catch(() => setState('notfound'));
  }, [code]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FDFBF7] px-4">
      <div className="text-center">
        {state === 'loading' && (
          <>
            <div className="w-10 h-10 border-4 border-[#C25934] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
            <div className="text-sm text-[#5C554F]">Apertura in corso...</div>
          </>
        )}
        {state === 'redirecting' && (
          <div className="text-sm text-[#5C554F]">Reindirizzamento...</div>
        )}
        {state === 'notfound' && (
          <>
            <div className="text-base font-semibold text-[#2A2624] mb-1" style={{ fontFamily: 'Outfit' }}>Link non valido</div>
            <div className="text-xs text-[#877E78]">Il link che hai aperto non esiste o è scaduto.</div>
          </>
        )}
      </div>
    </div>
  );
}
